// consoleInterceptor.ts
type ConsoleMethod = 'error' | 'warn'

type InterceptOptions = {
  methods?: ConsoleMethod[]
  match: (args: unknown[]) => boolean
  onMatch: (args: unknown[], method: ConsoleMethod) => void
  sampleRate?: number // 0..1
}

export function interceptConsole({ methods = ['error', 'warn'], match, onMatch, sampleRate = 1 }: InterceptOptions) {
  const originals: Partial<Record<ConsoleMethod, (...a: any[]) => void>> = {}

  methods.forEach((method) => {
    const original = console[method].bind(console)
    originals[method] = original

    console[method] = (...args: any[]) => {
      try {
        if (Math.random() <= sampleRate && match(args)) {
          onMatch(args, method)
        }
      } catch {
        // never break console
      } finally {
        original(...args)
      }
    }
  })

  // optional cleanup (useful in tests / HMR)
  return () => {
    methods.forEach((method) => {
      if (originals[method]) {
        console[method] = originals[method]!
      }
    })
  }
}
